
export const VERSION = '5.4.0'; // Update this manually on each release

